import { render, staticRenderFns } from "./ResellerTransactionReport.vue?vue&type=template&id=ad5dbfb0&scoped=true"
import script from "./ResellerTransactionReport.vue?vue&type=script&lang=js"
export * from "./ResellerTransactionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5dbfb0",
  null
  
)

export default component.exports